module.exports = __webpack_public_path__ + "img/switch.cdcbedcb.svg";